import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const foyPrimeNGTheme = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{red.50}',
      100: '{red.100}',
      200: '{red.200}',
      300: '{red.300}',
      400: '{red.400}',
      500: '{red.500}',
      600: '{red.600}',
      700: '{red.700}',
      800: '{red.800}',
      900: '{red.900}',
      950: '{red.950}'
    },
    // focusRing: {
    //   color: '{zinc.500}',
    //   shadow: '0 0 0 0.2rem {zinc.200}',
    //   offset: '2px'
    // },
    colorScheme: {
      light: {
        formField: {
          hoverBorderColor: '{zinc.400}',
          focusBorderColor: '{zinc.500}',
          focusRing: {
            color: '{zinc.500}',
            shadow: '0 0 0 0.2rem {zinc.200}'
          }
        }
      }
    }
  }
});

export default foyPrimeNGTheme;
